// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prompt-restore[data-v-e29c0b70]{margin:0}.bottom[data-v-e29c0b70]{display:flex;flex-direction:column;flex:1}.bottom .banner[data-v-e29c0b70]{margin-top:0}.bottom .buttons[data-v-e29c0b70]{display:flex;justify-content:flex-end;width:100%}", ""]);
// Exports
module.exports = exports;
